import styles from "../../css/button.module.css";
import PropTypes from "prop-types";

function Button({ text, onClick, ...rest }) {
  return (
    <button {...rest} className={styles.button} onClick={onClick}>
      {text}
    </button>
  );
}

Button.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default Button;
